export default __webpack_public_path__ + "static/media/AAE-Fire-Fx-02.13569e15.jpg";